import { ReactNode } from 'react';

import { Box } from '@chakra-ui/react';
import { CardContent, CollapsibleCard } from '@mesh.ai/rabbit';

import noInsights from 'assets/assetsV1/illustrations/deerIllustrations/noInsights.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

type Props = {
  children: ReactNode;
  title?: string;
  rightComp?: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => boolean;
  disabled?: boolean;
  isError?: boolean;
  emptyStateDescription?: string;
};

export const LifecycleOverviewSection = ({
  children,
  title,
  rightComp,
  open,
  onOpenChange,
  disabled,
  isError,
  emptyStateDescription,
}: Props) => (
  <CollapsibleCard title={title} actions={rightComp} open={open} disabled={disabled} onOpenChange={onOpenChange}>
    {isError ? (
      <Box width="100%">
        <CardContent>
          <EmptyScreen
            illustrationSrc={noInsights}
            heading="Not enough data to show"
            isSmallTextSize
            description={emptyStateDescription}
          />
        </CardContent>
      </Box>
    ) : (
      <Box width="100%">
        <CardContent>{children}</CardContent>
      </Box>
    )}
  </CollapsibleCard>
);
